import Form from '@rjsf/core'
import { fields, templates, widgets } from '../ui-schema-components'
import validator from '@rjsf/validator-ajv8'
import {
  CheckIcon,
  CreateSubstance,
  ModalDialog,
  Mtds,
  Substance,
  useCreateSubstanceMutation,
  useErrorToast
} from '../../index'
import type { RJSFSchema } from '@rjsf/utils'
import { useRef } from 'react'
import { useQueryClient } from '@tanstack/react-query'

const substanceSchema: RJSFSchema = {
  type: 'object',
  properties: {
    name: {
      type: 'string',
      title: 'Navn'
    },
    code: {
      type: 'string',
      title: 'SSD2-kode'
    },
    displayname: {
      type: 'string',
      title: 'Visningsnavn'
    }
  },
  required: ['name', 'code']
}

type CreateSubstanceModalProps = {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
  onCreated?: (substance: Substance) => void
}

export const CreateSubstanceModal = ({
  isOpen,
  setOpen,
  onCreated
}: CreateSubstanceModalProps) => {
  const createSubstance = useCreateSubstanceMutation()
  const queryClient = useQueryClient()
  const currentDataRef = useRef<CreateSubstance | undefined>(undefined)
  const showError = useErrorToast('opprette substansen')
  const onSubmit = async (
    formData: CreateSubstance | undefined
  ): Promise<void> => {
    if (formData != null) {
      try {
        const created = await createSubstance.mutateAsync(formData)
        if (onCreated) {
          await queryClient.refetchQueries({ queryKey: ['batch'] })
          onCreated(created)
        }
        Mtds.toast.success('Substansen er lagt til')
        setOpen(false)
      } catch (error) {
        showError(error)
      }
    }
  }
  return (
    <ModalDialog
      id={'create-substance-modal'}
      open={isOpen}
      onClose={(e) => {
        e.stopPropagation()
        setOpen(false)
      }}
    >
      <Mtds.Button
        command='close'
        commandfor={'create-substance-modal'}
        aria-label={'Lukk'}
      />
      <Mtds.Prose>
        <Mtds.Heading>Legg til substans</Mtds.Heading>
        <Form
          tagName={'div'}
          noHtml5Validate
          schema={substanceSchema}
          widgets={widgets}
          fields={fields}
          templates={templates}
          showErrorList={false}
          validator={validator}
          onChange={(e) => {
            currentDataRef.current = e.formData as CreateSubstance | undefined
          }}
        >
          <Mtds.Flex className='mt-8'>
            <Mtds.Button type='button' onClick={() => setOpen(false)}>
              Avbryt
            </Mtds.Button>
            <Mtds.Button
              data-variant='primary'
              type='button'
              onClick={async () => onSubmit(currentDataRef.current)}
            >
              <CheckIcon />
              Lagre
            </Mtds.Button>
          </Mtds.Flex>
        </Form>
      </Mtds.Prose>
    </ModalDialog>
  )
}
